import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

export const dataFunctionFR = (colorMode: 'light' | 'dark') => [
  {
    chapter: '1',
    chapterTitle: 'La population totale est plus importante qu’on le croit',
    absolutNumber: '9,7 mio',
    chartTitle: ["Population (Suisses de l'étranger inclus)"],
    chartParameters: [
      { barWidth: 100, barTitle: 'Population', barColor: '#FFDA40' },
    ],
    htmlParagraph: (
      <p>
        La population résidante permanente de la Suisse est de 8,9 millions de
        personnes. Si l'on compte également la population étrangère non
        permanente, ce sont même 9 millions de personnes qui vivent dans le
        pays. Nous avons toutefois utilisé le premier chiffre pour nos calculs
        et ajouté les 800’000 Suisses et Suissesses de l'étranger qui ont
        potentiellement le droit de vote.
      </p>
    ),
  },
  {
    chapter: '2',
    chapterTitle: 'Tout le monde ne peut pas voter',
    absolutNumber: '5,59 mio',
    chartTitle: ['Personnes ayant le droit de vote'],
    chartParameters: [
      {
        barWidth: 57.6,
        barTitle: 'avec droit de vote',
        barColor: '#FFDA40',
      },
      {
        barWidth: 42.4,
        barTitle: 'sans droit de vote',
        barColor: '#ffe4628a',
      },
    ],
    htmlParagraph: (
      <p>
        Parmi ces 9,7 millions de personnes, beaucoup ne peuvent pas se rendre
        aux urnes: plus de 4,1 millions – plus de 42% de la population –
        n'ont pas le droit de vote. Font partie de ce groupe les moins de 18
        ans, les citoyens et citoyennes qui souffrent, par exemple, de certains
        handicaps, ainsi que les étrangers et étrangères qui ne peuvent
        participer ni aux votations ni aux élections au niveau fédéral. Selon le
        canton et la commune, ils ont un droit de vote et d'éligibilité au
        niveau cantonal et communal.
      </p>
    ),
  },
  {
    chapter: '3',
    chapterTitle: 'Tout le monde ne vote pas',
    absolutNumber: '2,6 mio',
    chartTitle: ['Électeurs et électrices'],
    chartParameters: [
      { barWidth: 26.8, barTitle: 'ont voté', barColor: '#FFDA40' },
      {
        barWidth: 30.7,
        barTitle: 'n’ont pas voté',
        barColor: '#ffe4628a',
      },
      {
        barWidth: 42.4,
        barTitle: 'sans droit de vote',
        barColor: '#E9E9E9',
      },
    ],

    htmlParagraph: (
      <p>
        Il reste encore 5,59 millions de voix possibles. Or, le taux de
        participation n'était que de 46,6% dimanche dernier. Cela signifie que
        plus de la moitié des électeurs et électrices ne se sont pas rendus aux
        urnes. Ce sont donc 2,98 millions de personnes supplémentaires, soit
        30,7% de la population, qui ont ainsi été éliminées. Finalement, un peu
        plus de 2,6 millions de personnes ont effectivement participé aux
        élections, ce qui correspond à 26,8% de la population.
      </p>
    ),
  },
  {
    chapter: '4',
    chapterTitle: 'Tous les bulletins de vote ne sont pas valables',
    absolutNumber: '2,55 mio',
    chartTitle: ['Bulletins de vote valables'],
    chartParameters: [
      {
        barWidth: 26.3,
        barTitle: 'Bulletins valables',
        barColor: '#FFDA40',
        barByline: 'no',
      },
      {
        barWidth: 0.5,
        barTitle: 'votes non valables',
        barColor: '#ffe4628a',
        barByline: 'votes non valables',
      },
      {
        barWidth: 30.7,
        barTitle: <>n’ont pas voté</>,
        barColor: '#D4D4D4',
      },
      {
        barWidth: 42.4,
        barTitle: <>sans droit de vote</>,
        barColor: '#E9E9E9',
      },
    ],

    htmlParagraph: (
      <p>
        2’604’931 bulletins de vote ont été déposés. Cependant, près de 41'000
        d'entre eux n'étaient pas valables et plus de 9600 étaient blancs. Si
        l'on fait le compte, on arrive à 2,55 millions d'électeurs et
        d’électrices qui ont déposé des bulletins valables. Cela ne représente
        qu'un peu plus d'un quart de la population.
      </p>
    ),
  },
  {
    chapter: '5',
    chapterTitle: 'Il ne reste plus grand chose par parti',
    absolutNumber: '',
    chartTitle: ['Votes pour les partis'],
    chartParameters: [
      {
        barWidth: 7.3,
        barTitle: '',
        barColor: '#4b8a3e',
        barByline: 'UDC',
      },
      {
        barWidth: 4.8,
        barTitle: '',
        barColor: '#f0554d',
        barByline: 'PS',
      },
      {
        barWidth: 3.8,
        barTitle: '',
        barColor: '#3872b5',
        barByline: 'PLR',
      },
      {
        barWidth: 3.7,
        barTitle: '',
        barColor: '#d6862b',
        barByline: 'Centre',
      },
      {
        barWidth: 2.6,
        barTitle: '',
        barColor: '#84b547',
        barByline: 'Verts',
      },

      {
        barWidth: 2.0,
        barTitle: '',
        barColor: '#c4c43d',
        barByline: 'PVL',
      },
      {
        barWidth: 2.1,
        barTitle: '',
        barColor: '#b8b8b8',
        barByline: 'Autres',
      },
      {
        barWidth: 0.5,
        barTitle: 'Ungültige Stimmen',
        barColor: '#C8C8D1',
      },
      {
        barWidth: 30.7,
        barTitle: <>n’ont pas voté</>,
        barColor: '#D4D4D4',
      },
      {
        barWidth: 42.4,
        barTitle: <>sans droit de vote</>,
        barColor: '#E9E9E9',
      },
    ],
    htmlParagraph: (
      <>
        {' '}
        <p>
          Les 2’554’482 bulletins de vote valables se répartissent finalement
          encore entre les différents partis. En tant que vainqueur des
          élections, <span className='SVP'>l'UDC</span> a obtenu 27,9% de tous
          les sièges au Conseil national. Cela correspond à 712'000 électeurs et
          électrices, soit 7,3% de la population totale. Le{' '}
          <span className='SP'>PS</span>, deuxième force, obtient 4,8%. Le{' '}
          <span className='FDP'>PLR</span> arrive juste devant{' '}
          <span className='Mitte'>Le Centre</span>, car il a récolté un peu plus
          de 5000 voix de plus. Les <span className='Grünen'>Verts</span> et les{' '}
          <span className='GLP'>Vert’libéraux</span> ont été élus par moins de
          3% de la population.
        </p>
        <AutofitIFrame
          src={
            'https://datawrapper.dwcdn.net/KUEKF/3/' +
            '?dark=' +
            String(colorMode === 'dark')
          }
          style={{ marginTop: '1em' }}
        />
        <p>
          Si ces chiffres sont si bas, c'est avant tout en raison de la faible
          participation aux élections. Par rapport à 2019, celle-ci a certes
          légèrement augmenté (de 45,1% à 46,6%), mais elle stagne à un niveau
          similaire depuis des décennies. Malgré cela, le vote obligatoire n'est
          pas à l'ordre du jour en Suisse. Il n'y a que dans le canton de
          Schaffhouse que les personnes ayant le droit de vote mais qui ne se
          rendent pas aux urnes paient 6 francs.
        </p>
        <p>
          Pourtant, les analyses des dernières élections montrent qu'il y aurait
          bel et bien des changements si la majorité silencieuse allait
          également voter. Selon les sondages post-électoraux réalisés auprès
          des non-votants, le PLR, les Vert’libéraux et les Verts auraient
          obtenu des parts plus importantes en 2019 en cas de participation
          (hypothétique) de 100%. Le PS, le PDC et l'UDC auraient en revanche
          perdu des parts. Il est probable que les non-votants aient cette fois
          encore indirectement influencé le résultat.
        </p>
      </>
    ),
  },
]
